<template>
  <div>
    <div class="open-history-btn"
        @click="openHistoryModal()">
      <img :src="$anm22.icons.getWorldIcon('history')" />
      <div>{{ $anm22.strLang(lang, 'History', 'Cronologia') }}</div>
    </div>
    <!-- Modale con la cronologia delle modifiche -->
    <wg-modal v-if="openHistoryModalStatus" @closeModal="closeHistoryModal()" 
        :width="windowWidth > 700 ? '700px' : '90%'">
      <div slot="header" class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'History', 'Cronologia') }}</div>
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="wg-row">
          <!--<div class="wg-row" style="font-size:16px;">{{ $anm22.strLang(lang, 'Click on history item to restore it.', 'Clicca su un backup per ripristinarlo.') }}</div>
          <div class="vertical-height-div" style="height:20px;"></div>-->
          <div class="wg-row" style="align-items:center;justify-content:center;">
            <div class="wg-row history-item" v-for="historyDoc in historyDocs" :key="historyDoc.idPaglieraniProjectDocsLogs">
              <div class="history-item-label">
                <img :src="$anm22.icons.getWorldIcon('history')" />
                <!--div>{{ historyDoc.idPaglieraniProjectDocsLogs }}</div>-->
                <div class="date">{{ $moment.unix(historyDoc.timestamp).format('DD-MM-YYYY HH:mm') }}</div>
                <div class="date">{{ historyDoc.userName }}</div>
                <!--<img class="upload" :src="$anm22.icons.getWorldIcon('upload')" />-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploader.vue";

export default {
  components: {
    Anm22FileUploader
  },
  props: {
    projectId: [Number, String]
  },
  data() {
    return {
      confirmations: [],
      openHistoryModalStatus: false,
      historyDocs: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      windowWidth: state => state.windowWidth
    }), 
    project() {
      return this.$store.getters['projects/get']([this.projectId]);
    }
  },
  methods: {
    openHistoryModal() {
      this.openHistoryModalStatus = true;
      this.loadWidgetHistoryList();
    },
    closeHistoryModal() {
      this.openHistoryModalStatus = false;
      this.historyDocs = [];
    },
    loadWidgetHistoryList() {
      this.$http
        .get("paglierani/project-widget-list?projectId=" + this.project.idWorldProject)
        .then(response => {
          if (response.data) {
            if(response.data.docs) {
              this.historyDocs = response.data.docs;
            }
          }
        })
        .catch(error => console.log(error));
    },
    newRelease() {
      this.confirmations.push({
        date: this.$moment().unix(),
        files: [],
        notes: ""
      });
      this.saveForm();
    },
    async deleteRelease() {
      const index = this.selectedReleaseToDelete;
      this.selectedReleaseToDelete = null;
      this.confirmations.sort((a,b) => b.date - a.date).splice(index, 1);
      this.saveForm();
    },
    saveForm() {
      const docs = {...this.docs};
      docs.confirmations = this.confirmations;
      this.$emit('save', docs);
    },
    addFile(data) {
      if(data.url) {
        // get last release
        this.confirmations.sort((a,b) => b.date - a.date)[0].files.push({
          url: data.url,
          user: this.user.idWorldUser,
          ts: this.$moment().unix()
        });
        this.saveForm();
      }
    },
    async removeFile() {
      const release = this.selectedFileToDelete.release;
      const index = this.selectedFileToDelete.index;
      this.selectedFileToDelete = null;
      const url = release.files[index].url;
      release.files.splice(index, 1);
      this.saveForm();
    },
    openFile(file) {
      window.open(this.$anm22.getImagePath(file.url), '_blank');
    }
  },
  created() {
    
  }
}
</script>


<style lang="scss" scoped>
  .open-history-btn {
    cursor: pointer;
    border-top: 1px solid #eeeeee;
    padding-top: 15px;
    margin-top: 20px;
    width:100%;

    img {
      display: inline-block;
      height: 24px;
      vertical-align: middle;
      margin-right: 10px;
    }

    &>div {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
    }
  }

  .history-item {
    display:block;
    
    .history-item-label {
      font-size: 16px;

      img {
        display: inline-block;
        vertical-align: middle;
      }

      &>div {
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
      }
    }
  }
</style>
